import { render } from "./Loader.vue?vue&type=template&id=dfe28d88&scoped=true"
const script = {}

import "./Loader.vue?vue&type=style&index=0&id=dfe28d88&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfe28d88"]])

export default __exports__